import styled from "styled-components";

const buttonColorTable = {
  green: {
    backgroundColor: "#8bc541",
    color: "#fff",
    hover: {
      backgroundColor: "#73943f",
      color: "#fff"
    }
  },
  grey: {
    backgroundColor: "#eee",
    color: "black",
    hover: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      color: "#fff"
    }
  },
  lightGray: {
    backgroundColor: "#e5e5e5",
    color: "#424242",
    hover: {
      backgroundColor: "#f6f6f6",
      color: "#424242"
    }
  },
  darkGray: {
    backgroundColor: "#424242",
    color: "#fff",
    hover: {
      backgroundColor: "#747474",
      color: "#fff"
    }
  }
};

export const ButtonWrapper = styled.div`
  width: ${props => props.width ? props.width : "110px"};
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  font-weight: 600;
  font-size: 16px;
  color: ${props => buttonColorTable[props.color].color};
  background-color: ${props => buttonColorTable[props.color].backgroundColor};
  cursor: pointer;
  &:hover {
    color: ${props => buttonColorTable[props.color].hover.color};
    background-color: ${props =>
      buttonColorTable[props.color].hover.backgroundColor};
  }
`;
